import EventBus from "./event-bus";
import {millisToDate} from "./utils";
import {bookingChannelSource} from "./hosts";

let header = {
  headers: {
    appId:'boriumweb',
    appKey: 'iasofjsovsdlvsdvlsnflsfhuawefawefnwaeflnjnv-=sf',
    "Content-Type": "application/json",
  }
}
let boriumUrl = 'https://posapi.boriumstudio.com/';
// let boriumDbUrl = 'http://10.0.100.3:9090/api/public/'
const axios = require('axios');

export function getMerchants() {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true, "Getting Restaurant list");
    axios.get(boriumUrl + 'public_merchants.php', header)
      .then(function(response){
        EventBus.$emit("showLoading",false);
          // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit("showLoading",false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getTableList(subscriptionId) {
  return new Promise(function(resolve, reject) {
    const url = boriumUrl + 'tables.php?subscriptionId=' + subscriptionId;
    const tableHeader = {
      headers: {
        // "id":localStorage.getItem("id"),
        // "auth":localStorage.getItem("auth"),
        "dashboardId": localStorage.getItem("id"),
        "dashboardKey": 'boriumdashboard0812!',
        "Content-Type": "application/json"
      }
    };
    axios.get(url, tableHeader)
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        console.error('Request failed', err && err.response ? err.response.status : '');
        reject(err);
      })
  })
}
export function getProduct(pid) {
  return new Promise(function(resolve, reject) {
    let url = boriumUrl + 'publicProduct.php?pid='+ pid;
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Loading Product Information")
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getBookingSupportRestaurant(merchantId) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'booking/support/restaurant?id=' + merchantId, header)
      .then(function(response) {
        resolve(response.data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}

export function submitBookingSupport(item) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'booking/support', JSON.stringify(item), header)
      .then(function(response) {
        resolve(response.data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}

export function getMerchant(merchantId, type = null) {
  return new Promise(function(resolve, reject) {
    let url = boriumUrl + 'public_merchant.php?merchantId='+ merchantId;
    // console.log("URL to get merchant " + url);
    if(type != null) {
      url += '&type=' + type;
    }
    EventBus.$emit('showLoading', true, "Getting Restaurant")
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
         // console.log("Error at getting list " + err);
         // if(err.response != undefined) {
         //   console.log(err.response);
         // }
        reject(err);
      })
  })
}
export function getMerchantUrl(url) {
  return new Promise(function(resolve, reject) {
    const lookup = String(url || '');
    if (lookup.indexOf('showmethemenu.net') !== -1 || lookup.indexOf('eemo.app') !== -1) {
      resolve({ success: false, item: [], skipped: true, message: 'Platform host' });
      return;
    }
    url = boriumUrl + 'public_merchant.php?url='+ url;
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Getting Restaurant")
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getMerchantPermalink(permalink, type = null) {
  return new Promise(function(resolve, reject) {
    let url = boriumUrl + 'public_merchant.php?permalink='+ permalink;
    if(type != null) {
      url += '&type=' + type;
    }
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Getting Restaurant")
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getMerchantMenus(merchantId, type='web') {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Menus")
    let pre = new Date().getTime();
    axios.get(boriumUrl + 'public_menus.php?merchantId='+ merchantId+'&type='+type, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let n = new Date().getTime();
        let diff = n-pre;
        // console.log("took " + diff + "ms");
        // console.log("merchants menu list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getTableMerchant(tableId) {
  return new Promise(function(resolve, reject) {
    axios.get(boriumUrl + 'public_finder.php?tableId='+ tableId, header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function submitOrder(item) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'order/place', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function sendTableRequest(subscriptionId, cmd, request, tableId) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Sending request...");
    axios.get(process.env.SHOWMEMENU_API + 'merchant/table/request?subscriptionId=' + subscriptionId + "&cmd=" + cmd + "&request=" + request + "&tableId=" + tableId, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function submitLog(subscriptionId, site, type) {

  let item = {
    id:0,
    subscriptionId: subscriptionId,
    site:site,
    type:type,
    date:millisToDate(),
    hour:new Date().getHours(),

  }


  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'weblog', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function submitTableOrder(item) {
  return new Promise(function(resolve, reject) {
    let params = "tableId=" + item.tableId;
    params += "&orderId=" +item.id;
    if(item.memo != null && item.memo.length > 0) {
      params += "&memo=" + item.memo;
    }
    if(item.phoneNumber != null && item.phoneNumber.length > 0) {
      params += '&phoneNumber='+item.phoneNumber;
    }
    if(item.email != null && item.email.length > 0) {
      params += '&email=' + item.email;
    }
    if(item.headCount != undefined && item.headCount != null) {
      params += '&headCount=' + item.headCount;
    }
    axios.get(process.env.SHOWMEMENU_API + 'order/table/submit?' + params, header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function deleteTableItem(id) {
  return new Promise(function(resolve, reject) {
    axios.delete(process.env.SHOWMEMENU_API + 'order/table/item?id='+id, header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function updateTableItem(item) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'order/table/item', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function addItemsToTable(item) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "adding item");
    axios.post(process.env.SHOWMEMENU_API + 'order/table/add', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        EventBus.$emit('showLoading', false);
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function createNewPreOrder(order) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'preorder';
    EventBus.$emit('showLoading', true, "Creating Session")
    axios.put(url , JSON.stringify(order), header)
      .then(function(response) {
        // console.log("getOrderToken response");
        EventBus.$emit('showLoading', false);
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getPreOrder(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Session");
    let url = process.env.SHOWMEMENU_API + 'preorder?id='+id;
    axios.get(url , header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        // console.log("getOrderToken response");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function deletePreOrderItem(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Session");
    let url = process.env.SHOWMEMENU_API + 'preorder/item?id='+id;
    axios.delete(url , header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        // console.log("getOrderToken response");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function updatePreOrder(order) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'preorder', JSON.stringify(order), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function addPreOrderItem(item) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'preorder/item', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getTablePendingOrder(tableId) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'order/table/pending?tableId='+tableId;
    axios.get(url , header)
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function sendReceipt(id, email) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Sending Receipt");
    let url = process.env.SHOWMEMENU_API + 'order/receipt?id='+id + "&email=" + email;
    axios.get(url , header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        // console.log("getOrderToken response");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
/** Dojo hosted checkout: sk_sandbox_ / sk_prod_ key configured (no secrets returned). */
export function getDojoPaymentConfigStatus(subscriptionId) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'order/dojo/config?subscriptionId=' + subscriptionId;
    axios.get(url, header)
      .then(function(response) {
        resolve(response.data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}

/** Teya Hosted Checkout: enabled + client id/secret configured (no secrets returned). */
export function getTeyaPaymentConfigStatus(subscriptionId) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'order/teya/config?subscriptionId=' + subscriptionId;
    axios.get(url, header)
      .then(function(response) {
        resolve(response.data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}
export function getOrderPayments(id) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'order/payment?id='+id , header)
      .then(function(response) {
        // console.log("getOrderToken response");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getMyOrder(phoneNumber, merchantId) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'order/my?phoneNumber=' + phoneNumber + "&subscriptionId=" + merchantId, header)
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}
export function updateMyOrder(obj) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.SHOWMEMENU_API + 'order/update/status', JSON.stringify(obj), header)
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}


export function getDistance(from, to) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    var root = process.env.NODE_ENV === 'development'
      ? '/api/public/'
      : process.env.SHOWMEMENU_API;
    var url = root + 'delivery/distance?from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to);
    axios.get(url, header)
      .then(function(response) {
        let data = response.data;
        EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit("showLoading", false);
        console.error('Request failed', err && err.response ? err.response.status : '');
        reject(err);
      })
  })
}

export function getDeliveryAddresses(postcode) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true, "Finding address");
    var root = process.env.NODE_ENV === 'development'
      ? '/api/public/'
      : process.env.SHOWMEMENU_API;
    axios.get(root + 'delivery/addresses?postcode=' + encodeURIComponent(postcode), header)
      .then(function(response) {
        EventBus.$emit("showLoading", false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit("showLoading", false);
        reject(err);
      });
  })
}

export function getUserPoint(phoneNumber, merchantId) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.get(process.env.SHOWMEMENU_API + 'points/phoneNumber?phoneNumber='+phoneNumber + '&subscriptionId=' + merchantId, header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}
export function updatePaymentItem(order) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.post(process.env.SHOWMEMENU_API + 'order/card/paid', JSON.stringify(order), header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}

export function registerVisitor(visitor) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.post(process.env.SHOWMEMENU_API + 'visitor', JSON.stringify(visitor), header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}
export function setVisitorSeat(visitor) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.SHOWMEMENU_API + 'visitor/seat', JSON.stringify(visitor), header)
      .then(function(response) {
        let data = response.data;
        EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}
export function getOrder(id) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.get(process.env.SHOWMEMENU_API + 'order?orderId=' + id, header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}
export function getMyPendingOrder(phoneNumber) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.get(process.env.SHOWMEMENU_API + 'mypending/orders?phoneNumber=' + phoneNumber, header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}


export function getMyOrderDeliveryJob(id) {
  return new Promise(function(resolve, reject) {
    // EventBus.$emit("showLoading", true);
    axios.get(process.env.SHOWMEMENU_API + 'order/job?id=' + id, header)
      .then(function(response) {
        let data = response.data;
        // EventBus.$emit("showLoading", false);
        resolve(data);
      })
      .catch(function(err) {
        // EventBus.$emit("showLoading", false);
        reject(err);
      })
  })
}

export function getBookingTimeTable(merchantId) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'restaurant/' + merchantId + '/booking/table', header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function fullMarkAppliesToBookingType(full, bookingType) {
  const fullType = full && full.itemType != null ? String(full.itemType).trim() : '';
  if (fullType.length === 0 || fullType.toLowerCase() === 'all') {
    return true;
  }
  const selected = bookingType != null ? String(bookingType).trim() : '';
  return fullType === selected;
}

export function getBookingSlots(merchantId, date, bookingType) {
  const type = encodeURIComponent(bookingType == null ? '' : bookingType);
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'merchant/' + merchantId + '/booking/slots?date=' + date + '&bookingType=' + type, header)
      .then(function(response){
        resolve(response.data);
      })
      .catch(function(err) {
        reject(err);
      })
  })
}

export function getUnavailableBookingTime(merchantId, date) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'merchant/' + merchantId + '/booking/hours/unavailable?dateFrom=' + date + '&dateTo=' + date, header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getAvailableSlots(merchantId, numberOfGuest, date, time, query) {
  let url = process.env.SHOWMEMENU_API + 'booking/' + merchantId + "/" + numberOfGuest + "/" + date + "/" + time + "/availability";
  if(query !== null && query.length > 0) {
    url += "?" + query;
  }
  return new Promise(function(resolve, reject) {
    axios.get(url, header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getBookingTypes(merchantId) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'merchant/' + merchantId + '/hours/type/booking_type', header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getHolidayList(merchantId, date) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.SHOWMEMENU_API + 'merchant/' + merchantId + '/holidays?dateFrom=' + date, header)
      .then(function(response){
        // console.log("merchants list");
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function submitBooking(item) {
  return new Promise(function(resolve, reject) {
    if (item && !item.bookingSource) {
      item.bookingSource = bookingChannelSource();
    }
    axios.post(process.env.SHOWMEMENU_API + 'booking', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function submitReservedBooking(item) {
  return new Promise(function(resolve, reject) {
    if (item && !item.bookingSource) {
      item.bookingSource = bookingChannelSource();
    }
    axios.post(process.env.SHOWMEMENU_API + 'booking/submit', JSON.stringify(item), header)
      .then(function(response) {
        // console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function reserveBooking(item) {
  return new Promise(function(resolve, reject) {
    if (item && !item.bookingSource) {
      item.bookingSource = bookingChannelSource();
    }
    EventBus.$emit('showLoading', true, "Reserving a table");
    axios.post(process.env.SHOWMEMENU_API + 'booking/reserve', JSON.stringify(item), header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      })
  })
}

export function cancelReservedBooking(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Cancelling reserved table");
    axios.delete(process.env.SHOWMEMENU_API + 'booking/reserve/' + id + '/cancel', header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      })
  })
}
export function verifyBookingItemEmailAddress(id, code) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Verification in progress");
    axios.get(process.env.SHOWMEMENU_API + 'booking/verify/email/' + id + '?code=' + code, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function bookingCardDepositPreAuthorise(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Verification in progress");
    axios.get(process.env.SHOWMEMENU_API + 'booking/deposit/' + id, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function cancelBookingItem(id, key) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Cancellation in progress");
    axios.get(process.env.SHOWMEMENU_API + 'booking/customer/cancel/' + id + '?key=' + key, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getBookingItem(id, key) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Reservation Data")
    axios.get(process.env.SHOWMEMENU_API + 'booking/' + id + '?key=' + key, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
          let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getBookingMerchantItem(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Reservation Data")
    axios.get(process.env.SHOWMEMENU_API + 'booking/merchant/' + id, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getJonStatus() {
  let list = [
    {
      status:0,
      title:'Looking for rider',
    },
    {
      status:1,
      title:'Assigned',
    },
    {
      status:2,
      title:'Arrived at Restaurant',
    },
    {
      status:3,
      title:'Food Picked up',
    },
    {
      status:4,
      title:'Arrived at destination',
    },
    {
      status:5,
      title:'Food Delivered',
    }
  ];

  return list;
}
export function getMerchantSettings(subscriptionId, type) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Getting Reservation Data")
    axios.get(process.env.SHOWMEMENU_API + 'merchant/' + subscriptionId + '/settings?type='+type, header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function submitInquiryForm(form) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit('showLoading', true, "Submitting your inquiry")
    axios.post(process.env.SHOWMEMENU_API + 'merchant/inquiry/submit', JSON.stringify(form), header)
      .then(function(response) {
        // console.log(response);
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("ERrr placing order " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getLoyaltyCardEmail(email, mId, type) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/loyalty/'  + type + '?email='+ email + '&merchant=' + mId;
    // console.log("URL to get merchant " + url);

    axios.get(url, header)
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getJoinLoyaltyCard(form) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/loyalty/create';
    // console.log("URL to get merchant " + url);

    axios.post(url, JSON.stringify(form), header)
      .then(function(response){
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function registerPass(form) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/pass/register';

    EventBus.$emit('showLoading', true, "Registering your Pass");
    axios.post(url, JSON.stringify(form), header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      })
  })
}
export function acceptPassInvite(form) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/pass/invite/accept';
    EventBus.$emit('showLoading', true, 'Accepting your pass');
    axios.post(url, JSON.stringify(form), header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      });
  });
}
export function withEmailToken(url, emailToken) {
  if (!url || !emailToken) {
    return url;
  }
  return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'e=' + encodeURIComponent(emailToken);
}

export function emailTokenFromQueryOrUrl(queryE, registerUrl) {
  if (queryE) {
    return queryE;
  }
  if (!registerUrl) {
    return '';
  }
  let match = String(registerUrl).match(/[?&]e=([^&]+)/);
  if (!match) {
    return '';
  }
  try {
    return decodeURIComponent(match[1]);
  } catch (err) {
    return match[1];
  }
}

export function getPassWalletUrl(code, emailToken) {
  return withEmailToken(process.env.SHOWMEMENU_API + 'customer/pass/' + code + '/wallet', emailToken);
}
export function getPassGoogleWalletUrl(code, emailToken) {
  return withEmailToken(process.env.SHOWMEMENU_API + 'customer/pass/' + code + '/google-wallet', emailToken);
}
export function getPass(code, emailToken, invite) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/pass/' + code;
    let params = [];
    if (emailToken) {
      params.push('e=' + encodeURIComponent(emailToken));
    }
    if (invite) {
      params.push('invite=1');
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }

    EventBus.$emit('showLoading', true, "Getting your Pass");
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      })
  })
}
export function getPassMerchant(subscriptionId, permalink, domain) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/pass/merchant?';
    if (subscriptionId) {
      url += 'subscriptionId=' + encodeURIComponent(subscriptionId) + '&';
    }
    if (permalink) {
      url += 'permalink=' + encodeURIComponent(permalink) + '&';
    }
    if (domain) {
      url += 'domain=' + encodeURIComponent(domain);
    }
    EventBus.$emit('showLoading', true, 'Getting restaurant');
    axios.get(url, header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      });
  });
}
export function purchasePass(form) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/pass/purchase';
    EventBus.$emit('showLoading', true, 'Starting payment');
    axios.post(url, JSON.stringify(form), header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      });
  });
}
export function getLoyaltyMerchant(id, domain) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/loyalty/merchant/' + id;
    // console.log("URL to get merchant " + url);

    if(domain !== null && domain !== false && domain.length > 0) {
      url += "?domain=" + domain;
    }
    EventBus.$emit('showLoading', true, "Getting your Loyalty Card");
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function getLoyaltyInvitation(id) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/loyalty/invitation/' + id;
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Getting your Loyalty Card");
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function acceptLoyaltyInvitation(id, allowMarketing) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/loyalty/accept/invitation/' + id + '?allowMarketing=' + allowMarketing;
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Getting your Loyalty Card");
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function sendLoyaltyInvitation(form) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/loyalty/invite';
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Getting your Loyalty Card");
    axios.post(url, JSON.stringify(form), header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}
export function submitReviewRequest(form) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/loyalty/review/reward';
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Getting your Loyalty Card");
    axios.post(url, JSON.stringify(form), header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getCollectionTimeSlots(id, query) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'place/' + id + '/collection/slots';
    if(query !== null) {
      url += '?' + query;
    }
    // console.log("URL to get merchant " + url);

    EventBus.$emit('showLoading', true, "Get collection time slots");
    axios.get(url, header)
      .then(function(response){
        EventBus.$emit('showLoading', false);
        let data = response.data;
        resolve(data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        // console.log("Error at getting list " + err);
        // if(err.response != undefined) {
        //   console.log(err.response);
        // }
        reject(err);
      })
  })
}

export function getGiftCardMerchant(subscriptionId, permalink, domain) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/giftcard/merchant?';
    if (subscriptionId) {
      url += 'subscriptionId=' + encodeURIComponent(subscriptionId) + '&';
    }
    if (permalink) {
      url += 'permalink=' + encodeURIComponent(permalink) + '&';
    }
    if (domain) {
      url += 'domain=' + encodeURIComponent(domain);
    }
    EventBus.$emit('showLoading', true, 'Getting restaurant');
    axios.get(url, header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      });
  });
}

export function purchaseGiftCard(form) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/giftcard/purchase';
    EventBus.$emit('showLoading', true, 'Starting payment');
    axios.post(url, JSON.stringify(form), header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        console.error('Request failed', err && err.response ? err.response.status : '');
        reject(err);
      });
  });
}

export function getGiftCard(code, emailToken, invite, receipt) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/giftcard/' + encodeURIComponent(code);
    let params = [];
    if (emailToken) {
      params.push('e=' + encodeURIComponent(emailToken));
    }
    if (invite) {
      params.push('invite=1');
    }
    if (receipt) {
      params.push('receipt=1');
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    EventBus.$emit('showLoading', true, 'Getting your gift card');
    axios.get(url, header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      });
  });
}

export function registerGiftCard(form) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/giftcard/register';
    EventBus.$emit('showLoading', true, 'Registering your gift card');
    axios.post(url, JSON.stringify(form), header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      });
  });
}

export function acceptGiftCardInvite(form) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/giftcard/invite/accept';
    EventBus.$emit('showLoading', true, 'Accepting your gift card');
    axios.post(url, JSON.stringify(form), header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      });
  });
}

export function transferGiftCard(code, form) {
  return new Promise(function(resolve, reject) {
    let url = process.env.SHOWMEMENU_API + 'customer/giftcard/' + encodeURIComponent(code) + '/transfer';
    EventBus.$emit('showLoading', true, 'Sending gift card');
    axios.post(url, JSON.stringify(form), header)
      .then(function(response) {
        EventBus.$emit('showLoading', false);
        resolve(response.data);
      })
      .catch(function(err) {
        EventBus.$emit('showLoading', false);
        reject(err);
      });
  });
}

export function getGiftCardWalletUrl(code, emailToken) {
  return withEmailToken(process.env.SHOWMEMENU_API + 'customer/giftcard/' + encodeURIComponent(code) + '/wallet', emailToken);
}

export function getGiftCardGoogleWalletUrl(code, emailToken) {
  return withEmailToken(process.env.SHOWMEMENU_API + 'customer/giftcard/' + encodeURIComponent(code) + '/google-wallet', emailToken);
}

export function getLoyaltyWalletUrl(customerId) {
  return process.env.SHOWMEMENU_API + 'customer/loyalty/' + encodeURIComponent(customerId) + '/wallet';
}

export function getLoyaltyGoogleWalletUrl(customerId) {
  return process.env.SHOWMEMENU_API + 'customer/loyalty/' + encodeURIComponent(customerId) + '/google-wallet';
}



// WEBPACK FOOTER //
// ./src/api/borium.js